export const getCancelSubscription = (state) => {
	return state.showCancelSubscription
}